// extracted by mini-css-extract-plugin
module.exports = {"xIcon":"icon_xIcon__Of3Dj"};